"use client";

import { useEffect, useMemo } from "react";

type CssVarValue = string | null | undefined;

type RouteCssVarsProps = {
  vars: Record<string, CssVarValue>;
};

export function RouteCssVars({ vars }: RouteCssVarsProps) {
  const varsKey = useMemo(() => JSON.stringify(vars), [vars]);

  useEffect(() => {
    const root = document.documentElement;
    const previous = new Map<string, string | null>();
    const parsed = JSON.parse(varsKey) as Record<string, CssVarValue>;

    Object.entries(parsed).forEach(([key, value]) => {
      const cssKey = key.startsWith("--") ? key : `--${key}`;
      const prev = root.style.getPropertyValue(cssKey);
      previous.set(cssKey, prev ? prev : null);

      if (value == null) {
        root.style.removeProperty(cssKey);
      } else {
        root.style.setProperty(cssKey, value);
      }
    });

    return () => {
      previous.forEach((value, cssKey) => {
        if (value == null) {
          root.style.removeProperty(cssKey);
        } else {
          root.style.setProperty(cssKey, value);
        }
      });
    };
  }, [varsKey]);

  return null;
}





